import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { InfoBarOption } from '../schema/InfoBarMessageViewState';

/**
 *  Create the options for the menu
 *  @param options - The menu options
 *  @param optionStyle - The className style for the menu item
 *  @return menuItems of type IContextualMenuItem[]
 */
export default function createInfoBarMessageMenuOptions(
    options: InfoBarOption[],
    optionStyle: any
) {
    let menuItems: IContextualMenuItem[] = [];

    let i = 0;
    options.forEach(option => {
        menuItems.push({
            key: String(i),
            name: option.displayName,
            data: option,
            className: optionStyle,
        });

        i += 1;
    });

    return menuItems;
}
